module.exports = __webpack_public_path__ + "static/media/sort-arrow-asc.17036833.svg";